<div style="padding: 12px">
    <div class="one-row" style="align-items: center; gap: 8px; flex-wrap: wrap">
        <h1 [attr.data-cy]="'ggdgd_h1_1_4_'" style="margin: 0; flex: 1 1 auto"
            >Gruppe {{ gruppe?.bezeichnung }} {{ gruppe?.historie > 0 ? "(Historie)" : "" }} - {{ gruppe?.kunde }}
            {{ gruppe?.zusatz ? " - " + gruppe?.zusatz : "" }} {{ gruppe?.vvvo ? "(" + gruppe.vvvo + ")" : "" }}</h1
        >
    </div>

    <mat-tab-group #tabGroup (selectedTabChange)="tabChanged($event)" [selectedIndex]="selectedIndex">
        <mat-tab label="Tiere">
            <div *kienePermission="[1912, 9122, 9322, 9352]" style="margin-top: 24px">
                <ng-container *ngIf="+gruppe?.standard === 0">
                    <button
                        (click)="openGruppeEinstallenDialog()"
                        *kienePermission="[1912, 9122]"
                        color="accent"
                        [disabled]="gruppe?.historie > 0"
                        [attr.data-cy]="'ggdgd_button_1_0_'"
                        mat-flat-button
                    >
                        <mat-icon [attr.data-cy]="'ggdgd_mat-icon_1_2_'">login</mat-icon>
                        <span>&nbsp;Tiere einstallen</span>
                    </button>
                </ng-container>
                <button
                    (click)="ausstallen()"
                    *kienePermission="[9322]"
                    color="accent"
                    mat-flat-button
                    [disabled]="gruppe?.historie > 0 || (kieneTable?.getSelectedRows()?.length ?? 0) === 0"
                    [attr.data-cy]="'ggdgd_button_2_0_'"
                    style="margin-left: 12px"
                >
                    <mat-icon [attr.data-cy]="'ggdgd_mat-icon_2_2_'">logout</mat-icon>
                    <span>&nbsp;(selektierte) Tiere ausstallen</span>
                </button>
                <ng-container *ngIf="rindermast">
                    <button
                        (click)="gruppeZuweisen()"
                        *kienePermission="[9122]"
                        [disabled]="kieneTable.getSelectedRows().length === 0"
                        color="accent"
                        mat-flat-button
                        style="margin-left: 12px"
                        [attr.data-cy]="'ggdgd_button_3_0_'"
                    >
                        <mat-icon [attr.data-cy]="'ggdgd_mat-icon_3_2_'">sync_alt</mat-icon>
                        <span>&nbsp;selektierte Tiere: Gruppe ändern</span>
                    </button>
                </ng-container>
                <ng-container *ngIf="+gruppe?.standard === 0">
                    <button
                        (click)="standortwechsel()"
                        color="accent"
                        mat-flat-button
                        style="margin-left: 12px"
                        [disabled]="gruppe?.historie > 0 || !canUseStandortwechsel()"
                        [attr.data-cy]="'ggdgd_button_4_0_'"
                    >
                        <mat-icon [attr.data-cy]="'ggdgd_mat-icon_4_2_'">swap_horiz</mat-icon>
                        <span>&nbsp;Standort wechseln</span>
                    </button>
                </ng-container>
            </div>

            <kiene-kiene-table #kieneTable [tableDescriptor]="tableDescriptor">
                <div toolbarElementTop>
                    <div class="one-row">
                        <span class="spacer"></span>

                        <button
                            (click)="selectedRows = kieneTable.getSelectedRows()"
                            *ngIf="!isSGS"
                            [matMenuTriggerFor]="tableMenu"
                            mat-icon-button
                            [attr.data-cy]="'ggdgd_button_6_0_'"
                        >
                            <mat-icon [attr.data-cy]="'ggdgd_mat-icon_6_2_'">more_vert</mat-icon>
                        </button>

                        <mat-menu #tableMenu="matMenu" class="mat-menu--desktop-gruppe-details" style="min-width: 20vw">
                            <button
                                (click)="eingescanntePaesseVerwalten()"
                                *kienePermission="[9361]"
                                mat-menu-item
                                [disabled]="gruppe?.historie > 0"
                                [attr.data-cy]="'ggdgd_button_7_0_'"
                            >
                                <mat-icon color="accent" [attr.data-cy]="'ggdgd_mat-icon_7_2_'">scanner</mat-icon>
                                <span>Eingescannte P&auml;sse verwalten</span>
                            </button>
                            <mat-divider></mat-divider>
                            <button
                                (click)="tiereAusHitNachladen()"
                                *kienePermission="[1912]"
                                mat-menu-item
                                [disabled]="gruppe?.historie > 0"
                                [attr.data-cy]="'ggdgd_button_hit_sync_'"
                            >
                                <mat-icon color="accent" [attr.data-cy]="'ggdgd_mat-icon_hit_sync_'">cloud_sync</mat-icon>
                                Tiere mit HIT synchronisieren
                            </button>
                            <button
                                (click)="zugaengeMelden()"
                                *kienePermission="[9126]"
                                mat-menu-item
                                [disabled]="gruppe?.historie > 0"
                                [attr.data-cy]="'ggdgd_button_8_0_'"
                            >
                                <mat-icon
                                    color="accent"
                                    style="transform: rotateY(180deg)"
                                    [attr.data-cy]="'ggdgd_mat-icon_8_2_'"
                                    >cloud_sync</mat-icon
                                >
                                Zugänge an HIT melden
                            </button>
                            <button
                                (click)="abgaengeMelden()"
                                *kienePermission="[9126]"
                                mat-menu-item
                                [disabled]="gruppe?.historie > 0"
                                [attr.data-cy]="'ggdgd_button_9_0_'"
                            >
                                <mat-icon
                                    color="accent"
                                    style="transform: rotateY(180deg)"
                                    [attr.data-cy]="'ggdgd_mat-icon_9_2_'"
                                    >cloud_sync</mat-icon
                                >
                                Abgänge an HIT melden
                            </button>
                            <mat-divider></mat-divider>
                            <ng-container *kienePermission="[9377]">
                                <button
                                    (click)="zertifikateAnSGS()"
                                    *ngIf="this.gruppe?.sgs > 0"
                                    [attr.data-cy]="'ggdgd_button_10_0_'"
                                    mat-menu-item
                                    [disabled]="gruppe?.historie > 0"
                                >
                                    <mat-icon color="accent" [attr.data-cy]="'ggdgd_mat-icon_10_2_'">biotech</mat-icon>
                                    Zertifizierungsdatei an SGS senden (alle Tiere)
                                </button>
                            </ng-container>
                            <button
                                #menuTrigger="matMenuTrigger"
                                *kienePermission="[9116, 9121, 1971, 9122]"
                                [matMenuTriggerFor]="tierlistenMenu"
                                mat-menu-item
                                [attr.data-cy]="'ggdgd_button_11_0_'"
                            >
                                <mat-icon color="accent" [attr.data-cy]="'ggdgd_mat-icon_11_2_'">summarize</mat-icon>
                                <span>Download / Upload</span>
                            </button>
                            <mat-menu #tierlistenMenu="matMenu">
                                <button
                                    (click)="downloadReklamationsPdf()"
                                    *kienePermission="[9116]"
                                    mat-menu-item
                                    [attr.data-cy]="'ggdgd_button_12_0_'"
                                >
                                    <mat-icon color="accent" [attr.data-cy]="'ggdgd_mat-icon_12_2_'"
                                        >picture_as_pdf</mat-icon
                                    >
                                    Reklamationsliste
                                </button>
                                <button
                                    (click)="downloadGruppeCsv()"
                                    *kienePermission="[9121]"
                                    mat-menu-item
                                    [attr.data-cy]="'ggdgd_button_13_0_'"
                                >
                                    <mat-icon color="accent" [attr.data-cy]="'ggdgd_mat-icon_13_2_'"
                                        >table_chart</mat-icon
                                    >
                                    CSV-Datei aller Tiere
                                </button>
                                <button
                                    (click)="downloadGruppeExcel()"
                                    *kienePermission="[9121]"
                                    mat-menu-item
                                    [attr.data-cy]="'ggdgd_button_14_0_'"
                                >
                                    <mat-icon color="accent" [attr.data-cy]="'ggdgd_mat-icon_14_2_'"
                                        >table_chart</mat-icon
                                    >
                                    Excel-Datei aller Tiere
                                </button>
                                <buton (click)="downloadGruppePdf()" *kienePermission="[9121]" mat-menu-item>
                                    <mat-icon color="accent" [attr.data-cy]="'ggdgd_mat-icon_15_2_'"
                                        >picture_as_pdf</mat-icon
                                    >
                                    PDF-Datei aller Tiere
                                </buton>
                                <button
                                    (click)="openAbgangslisteDownloadDialog()"
                                    *kienePermission="[1971]"
                                    mat-menu-item
                                    [attr.data-cy]="'ggdgd_button_15_0_'"
                                >
                                    <mat-icon color="accent" [attr.data-cy]="'ggdgd_mat-icon_16_2_'">download</mat-icon>
                                    Ausstallliste / Lieferschein
                                </button>
                                <button
                                    (click)="uploadTiereCSV()"
                                    *kienePermission="[9122]"
                                    mat-menu-item
                                    [disabled]="gruppe?.historie > 0"
                                    [attr.data-cy]="'ggdgd_button_16_0_'"
                                >
                                    <mat-icon color="accent" [attr.data-cy]="'ggdgd_mat-icon_17_2_'">upload</mat-icon>
                                    Tierliste hochladen
                                </button>
                            </mat-menu>
                            <mat-divider></mat-divider>
                            <button
                                *kienePermission="[9122, 9124, 9128, 9129, 9178, 11015, 11016, 9161]"
                                [disabled]="gruppe?.historie > 0 || selectedRows?.length === 0"
                                [attr.data-cy]="'ggdgd_button_17_0_'"
                                [matMenuTriggerFor]="selektierteMenu"
                                mat-menu-item
                            >
                                <mat-icon color="accent" [attr.data-cy]="'ggdgd_mat-icon_18_2_'">edit</mat-icon>
                                <span>Aktionen für selektierte Tiere</span>
                            </button>
                            <mat-menu #selektierteMenu="matMenu">
                                <button
                                    (click)="alleOhrmarkenGescannt()"
                                    *kienePermission="[9122]"
                                    mat-menu-item
                                    [disabled]="gruppe?.historie > 0"
                                    [attr.data-cy]="'ggdgd_button_18_0_'"
                                >
                                    <mat-icon color="accent" [attr.data-cy]="'ggdgd_mat-icon_19_2_'">label</mat-icon>
                                    <span>Ohrmarken als gescannt markieren</span>
                                </button>
                                <button
                                    (click)="addCommentToSelected()"
                                    *kienePermission="[9129]"
                                    [disabled]="kieneTable.getSelectedRows().length === 0"
                                    mat-menu-item
                                    [attr.data-cy]="'ggdgd_button_19_0_'"
                                >
                                    <mat-icon color="accent" [attr.data-cy]="'ggdgd_mat-icon_20_2_'"
                                        >add_comment</mat-icon
                                    >
                                    <span>Bemerkung hinzufügen</span>
                                </button>
                                <button
                                    (click)="gruppeZuweisen()"
                                    *kienePermission="[9122]"
                                    mat-menu-item
                                    [disabled]="gruppe?.historie > 0"
                                    [attr.data-cy]="'ggdgd_button_20_0_'"
                                >
                                    <mat-icon color="accent" [attr.data-cy]="'ggdgd_mat-icon_21_2_'">sync_alt</mat-icon>
                                    <span>Gruppe ändern</span>
                                </button>
                                <button
                                    (click)="abteilAendern()"
                                    *kienePermission="[9122]"
                                    mat-menu-item
                                    [disabled]="gruppe?.historie > 0"
                                    [attr.data-cy]="'ggdgd_button_21_0_'"
                                >
                                    <mat-icon color="accent" [attr.data-cy]="'ggdgd_mat-icon_22_2_'">sync_alt</mat-icon>
                                    <span>Abteil ändern</span>
                                </button>
                                <button
                                    (click)="haendlerAendern()"
                                    *kienePermission="[9178]"
                                    mat-menu-item
                                    [disabled]="gruppe?.historie > 0"
                                    [attr.data-cy]="'ggdgd_button_22_0_'"
                                >
                                    <mat-icon color="accent" [attr.data-cy]="'ggdgd_mat-icon_23_2_'">sync_alt</mat-icon>
                                    <span>Händler ändern</span>
                                </button>
                                <button
                                    (click)="openKontaktSetzenDialog()"
                                    *kienePermission="[11014]"
                                    mat-menu-item
                                    [disabled]="gruppe?.historie > 0"
                                    [attr.data-cy]="'ggdgd_button_kontakt_setzen'"
                                >
                                    <mat-icon color="accent" [attr.data-cy]="'ggdgd_mat-icon_kontakt_setzen'">
                                        contacts
                                    </mat-icon>
                                    <span>Kontakt zuordnen</span>
                                </button>
                                <button
                                    (click)="openHerkunftSetzenDialog()"
                                    *kienePermission="[11014]"
                                    mat-menu-item
                                    [disabled]="gruppe?.historie > 0"
                                    [attr.data-cy]="'ggdgd_button_herkunft_setzen'"
                                >
                                    <mat-icon color="accent" [attr.data-cy]="'ggdgd_mat-icon_herkunft_setzen'">
                                        location_on
                                    </mat-icon>
                                    <span>Herkunftsbetrieb setzen</span>
                                </button>
                                <button
                                    (click)="openReklamationenSetzenDialog()"
                                    *kienePermission="[9129]"
                                    mat-menu-item
                                    [disabled]="gruppe?.historie > 0"
                                    [attr.data-cy]="'ggdgd_button_reklamationen_setzen'"
                                >
                                    <mat-icon color="accent" [attr.data-cy]="'ggdgd_mat-icon_reklamationen_setzen'">
                                        report_problem
                                    </mat-icon>
                                    <span>Reklamationen setzen</span>
                                </button>
                                <button
                                    (click)="openMehrereEinstalldatumAendernDialog(this.selectedRows)"
                                    *kienePermission="[9128]"
                                    [disabled]="gruppe?.historie > 0 || isAusstalldatumAenderDisabled()"
                                    mat-menu-item
                                    [attr.data-cy]="'ggdgd_button_23_0_'"
                                >
                                    <mat-icon color="accent" [attr.data-cy]="'ggdgd_mat-icon_24_2_'">today</mat-icon>
                                    <span>Einstalldatum ändern</span>
                                </button>
                                <button
                                    (click)="openMehrereAbgangsdatumAendernDialog(this.selectedRows)"
                                    *kienePermission="[9129]"
                                    [disabled]="gruppe?.historie > 0 || isEinstalldatumAendernDisabled()"
                                    mat-menu-item
                                    [attr.data-cy]="'ggdgd_button_24_0_'"
                                >
                                    <mat-icon color="accent" [attr.data-cy]="'ggdgd_mat-icon_25_2_'">event</mat-icon>
                                    <span>Abgangsdatum ändern</span>
                                </button>
                                <button
                                    (click)="zertifikateAnSgsEinzeln(this.selectedRows)"
                                    *kienePermission="[9377]"
                                    mat-menu-item
                                    [disabled]="gruppe?.historie > 0 || gruppe?.betriebsart_id !== 3035"
                                    [attr.data-cy]="'ggdgd_button_25_0_'"
                                >
                                    <mat-icon color="accent" [attr.data-cy]="'ggdgd_mat-icon_26_2_'">biotech</mat-icon>
                                    <span>Zertifizierungsdatei an SGS senden</span>
                                </button>
                                <ng-container *ngIf="darfBio()">
                                    <button
                                        (click)="openPreiseFestlegenDialog()"
                                        *kienePermission="[11015]"
                                        mat-menu-item
                                        [disabled]="gruppe?.historie > 0"
                                        [attr.data-cy]="'ggdgd_button_preise_festlegen'"
                                    >
                                        <mat-icon color="accent" [attr.data-cy]="'ggdgd_mat-icon_preise_festlegen'"
                                            >euro</mat-icon
                                        >
                                        <span>Preise festlegen</span>
                                    </button>
                                    <button
                                        (click)="openGewichteFestlegenDialog()"
                                        mat-menu-item
                                        [disabled]="gruppe?.historie > 0 || !canChangeGewichte()"
                                        [attr.data-cy]="'ggdgd_button_gewichte_festlegen'"
                                    >
                                        <mat-icon color="accent" [attr.data-cy]="'ggdgd_mat-icon_gewichte_festlegen'"
                                            >fitness_center</mat-icon
                                        >
                                        <span>Gewichte festlegen</span>
                                    </button>
                                </ng-container>
                                <button
                                    (click)="openAussendienstSetzenDialog()"
                                    *kienePermission="[11016]"
                                    mat-menu-item
                                    [disabled]="gruppe?.historie > 0"
                                    [attr.data-cy]="'ggdgd_button_aussendienst_setzen'"
                                >
                                    <mat-icon color="accent" [attr.data-cy]="'ggdgd_mat-icon_aussendienst_setzen'"
                                        >person</mat-icon
                                    >
                                    <span>Außendienst setzen</span>
                                </button>
                            </mat-menu>
                        </mat-menu>

                        <kiene-gruppe-tier-filter-button
                            #filterButton
                            (filterSelected)="setFilterSettings($event)"
                            *ngIf="!isSGS"
                            [gruppe]="gruppe"
                            [persistToSpeicher]="true"
                            [saveFilterEnabled]="filterSaveEnabled"
                            (saveFilterEnabledChange)="filterSaveEnabled = $event"
                            [tierFilterSettings]="filterSettings"
                        >
                        </kiene-gruppe-tier-filter-button>

                        <!--                <button matTooltip="Einstallen" *kienePermission="[9121]" mat-icon-button (click)="openEinstalldatumAendernDialog()" [attr.data-cy]="'ggdgd_button_26_0_'">-->
                        <!--                    <mat-icon color="accent" [attr.data-cy]="'ggdgd_mat-icon_27_2_'">login</mat-icon>-->
                        <!--                </button>-->

                        <!--                this.openEinstalldatumAendernDialog(event.values)-->
                    </div>
                </div>
            </kiene-kiene-table>
        </mat-tab>

        <mat-tab label="Details, Verlauf & Statistiken">
            <div class="details-toolbar">
                <ng-container *ngIf="+gruppe?.standard === 0">
                    <button
                        (click)="openGruppeInformationenDialog()"
                        *kienePermission="[1912]"
                        color="accent"
                        mat-flat-button
                        [attr.data-cy]="'ggdgd_button_27_0_'"
                    >
                        <mat-icon [attr.data-cy]="'ggdgd_mat-icon_28_2_'">edit_note</mat-icon>
                        <span>&nbsp;Informationen bearbeiten</span>
                    </button>
                </ng-container>
            </div>

            <mat-expansion-panel class="details-panel" [disabled]="!statistikOpenable()" [expanded]="true">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="panel-title">
                            <mat-icon [attr.data-cy]="'ggdgd_mat-icon_29_2_'">info</mat-icon>
                            <span>Gruppendetails</span>
                        </div>
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <div class="panel-body panel-body--table">
                <div class="details-grid">
                    <div class="details-item"><span class="details-label">Herdenname</span><span class="details-value">{{ gruppe?.herdenname || "---" }}</span></div>
                    <div class="details-item"><span class="details-label">Anzahl Tiere</span><span class="details-value">{{ gruppe?.anzahl_tiere_gesamt || "---" }}</span></div>
                    <div class="details-item"><span class="details-label">Tiere gescannt</span><span class="details-value">{{ gruppe?.anzahl_tiere_ohrmarken || "---" }} {{ getDifferenceString(gruppe?.anzahl_tiere_ohrmarken, gruppe?.anzahl_tiere_gesamt) }}</span></div>
                    <div class="details-item"><span class="details-label">Abgänge</span><span class="details-value">{{ gruppe?.anzahl_abgaenge || "---" }} {{ getDifferenceString(gruppe?.anzahl_abgaenge, gruppe?.anzahl_tiere_gesamt, { asPercentage: true }) }}</span></div>
                    <div class="details-item"><span class="details-label">Standort</span><span class="details-value">{{ gruppe?.stall || "---" }}</span></div>
                    <div class="details-item"><span class="details-label">Laut HIT</span><span class="details-value">{{ gruppe?.anzahl_tiere_hit || "---" }} {{ getDifferenceString(gruppe?.anzahl_tiere_hit, gruppe?.anzahl_tiere_gesamt) }}</span></div>
                    <div class="details-item"><span class="details-label">Tiere ohne Pass</span><span class="details-value">{{ gruppe?.tiere_ohne_pass || "---" }}</span></div>
                    <div class="details-item"><span class="details-label">Tote</span><span class="details-value">{{ gruppe?.anzahl_tote || "---" }} {{ getDifferenceString(gruppe?.anzahl_tote, gruppe?.anzahl_tiere_gesamt, { asPercentage: true }) }}</span></div>
                    <div class="details-item"><span class="details-label">Einstallzeitraum</span><span class="details-value">{{ (gruppe?.einstalldatum_von | date: "dd.MM.yy") || "---" }} - {{ (gruppe?.einstalldatum_bis | date: "dd.MM.yy") || "---" }}</span></div>
                    <div class="details-item"><span class="details-label">Alter</span><span class="details-value">{{ gruppe?.alter_wochen || "---" }} Wochen</span></div>
                    <div class="details-item"><span class="details-label">Pässe ohne Tier</span><span class="details-value">{{ gruppe?.paesse_ohne_tier || "---" }}</span></div>
                    <div class="details-item"><span class="details-label">Anzahl Tiere aktuell</span><span class="details-value">{{ gruppe?.anzahl_tiere_aktuell || "---" }}</span></div>
                    <div class="details-item"><span class="details-label">Produktionsabschnitt</span><span class="details-value">{{ gruppe?.produktionsabschnitt || "---" }} seit {{ (gruppe?.datum_von | date: "dd.MM.yy") || "---" }}</span></div>
                    <div class="details-item details-item--full"><span class="details-label">Informationen</span><span class="details-value">{{ gruppe?.informationen || "---" }}</span></div>
                </div>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel class="details-panel" [disabled]="verlaufIsLoading || !verlaufOpenable()" [expanded]="true">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="panel-title panel-title--with-count">
                            <mat-icon [attr.data-cy]="'ggdgd_mat-icon_30_2_'">history</mat-icon>
                            <span>{{
                                gruppenVerlauf?.length === 0 ? "Verlauf - keine Ereignisse vorhanden" : "Verlauf"
                            }}</span>
                            <span>{{
                                gruppenVerlauf && gruppenVerlauf.length > 0 ? "(" + gruppenVerlauf?.length + ")" : ""
                            }}</span>
                            <span class="spacer"></span>
                        </div>
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <div class="panel-body panel-body--table">
                <ul class="verlauf-list">
                    <li *ngFor="let gb of gruppenVerlauf" class="verlauf-item">
                        <mat-icon [ngStyle]="{ color: getIconColor(gb.icon) }" [attr.data-cy]="'ggdgd_mat-icon_31_2_'">{{
                            getIcon(gb.icon)
                        }}</mat-icon>
                        <span class="verlauf-date">{{ gb.datum | date: "dd.MM.yyyy" }}</span>
                        <span class="verlauf-text">{{ gb.txt }}</span>
                    </li>
                </ul>
                </div>

                <!--                <div>-->
                <!--                    <div *ngFor="let verlaufEintrag of gruppenVerlauf" class="verlauf one-row">-->
                <!--                        <mat-icon [attr.data-cy]="'ggdgd_mat-icon_32_2_'">{{ verlaufEintrag.icon }}</mat-icon>-->
                <!--                        <span>{{ verlaufEintrag.datum | date: "dd.MM.YY" }}</span>-->
                <!--                        <span>{{ verlaufEintrag.txt }}</span>-->
                <!--                        <span class="spacer"></span>-->
                <!--                    </div>-->

                <!--                </div>-->
            </mat-expansion-panel>

            <mat-expansion-panel class="details-panel" [disabled]="!statistikOpenable()" [expanded]="true">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="panel-title">
                            <mat-icon [attr.data-cy]="'ggdgd_mat-icon_33_2_'">assessment</mat-icon>
                            <span>Statistiken ({{ gibAnzahlStatistiken() }})</span>
                        </div>
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <div class="panel-body panel-body--table">
                    <div class="stats-block" *ngIf="gruppenStatistik?.rassen?.length > 0">
                        <div class="stats-title"><strong>Rassen</strong></div>
                        <div *ngFor="let r of gruppenStatistik?.rassen" class="stats-row"><span class="stats-label">{{ r.rasse }}</span><span class="stats-value">{{ r.anzahl }}x</span></div>
                    </div>
                    <div class="stats-block" *ngIf="gruppenStatistik?.geschlechter?.length > 0">
                        <div class="stats-title"><strong>Anzahl Geschlechter</strong></div>
                        <div *ngFor="let g of gruppenStatistik?.geschlechter" class="stats-row"><span class="stats-label">{{ g.geschlecht }}</span><span class="stats-value">{{ g.anzahl }}x</span></div>
                    </div>
                    <div class="stats-block" *ngIf="gruppenStatistik?.reklamationen?.length > 0">
                        <div class="stats-title"><strong>Anzahl Reklamationen</strong></div>
                        <div *ngFor="let g of gruppenStatistik?.reklamationen" class="stats-row"><span class="stats-label">{{ g.reklamation }}</span><span class="stats-value">{{ g.anzahl }}x</span></div>
                    </div>
                    <div class="stats-block" *ngIf="gruppenStatistik?.abteile?.length > 0">
                        <div class="stats-title"><strong>Tiere je Abteil</strong></div>
                        <div *ngFor="let a of gruppenStatistik?.abteile" class="stats-row"><span class="stats-label">{{ a?.abteil }}</span><span class="stats-value">{{ a?.anzahl }}x</span></div>
                    </div>
                </div>
            </mat-expansion-panel>
        </mat-tab>

        <ng-container *ngIf="+gruppe?.standard === 0 && darfBio()">
            <mat-tab *kienePermission="[9351, 9161, 9162]" label="Standorte, Gewichte & Preise">
                <div style="width: 100%">
                    <kiene-gruppe-standort-verwalten
                        [filterSettings]="filterSettings"
                        [gruppe]="gruppe"
                    ></kiene-gruppe-standort-verwalten>
                </div>
            </mat-tab>
        </ng-container>

        <ng-container *ngIf="darfBio()">
            <mat-tab *kienePermission="[9161, 9162]" label="Auswertungen">
                <kiene-gewichte-preise [gruppe_id]="gruppe?.gruppe_id"></kiene-gewichte-preise>
            </mat-tab>
        </ng-container>

        <ng-container *ngIf="darfBelege()">
            <mat-tab label="Belege" *kienePermission="[9380]">
                <kiene-gruppe-belege [gruppe]="gruppe"></kiene-gruppe-belege>
            </mat-tab>
        </ng-container>
    </mat-tab-group>
</div>
